import { Controller } from "@hotwired/stimulus";

// Gates the "presence" fields (which-page, screen name — and message-me, unless
// the tenant decouples messaging from presence) behind the master "Show others
// when I'm online" checkbox, mirroring the server-side rule
// User#validate_social_available_when_online: those fields may only be set when
// the master is on. The view decides per field what is gated: a field without
// the "dependent" target (see User#messaging_decoupled_from_presence?) is
// left alone. Without this, a user can fill them in with the master off
// and the whole wizard step fails validation on save.
//
// When the master is off we don't just disable — a disabled field isn't
// submitted, so the model would keep its old value and still fail. We instead
// blank/uncheck and gate so the (now-empty) values submit and the record stays
// valid: checkboxes get unchecked + disabled (their hidden "0" still submits),
// text inputs get cleared + readonly (readonly still submits "").
export default class extends Controller {
  static targets = ["master", "dependent"];

  connect() {
    this.toggle();
  }

  toggle() {
    const on = this.masterTarget.checked;
    this.dependentTargets.forEach((el) => {
      el.style.opacity = on ? "1" : ".45";
      el.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        if (!on) cb.checked = false;
        cb.disabled = !on;
      });
      el.querySelectorAll('input[type="text"], textarea').forEach((f) => {
        if (!on) f.value = "";
        f.readOnly = !on;
      });
    });
  }
}
